import { IErrorResponse } from '../types/interfaces';
export const retryDeferMap: Record<string, typePrefixCaughtOnSubbedThunks[]> = {};

export interface PipedErrorPayload {
    reduxThunkType: string;
    data: IErrorResponse;
}
export type typePrefixCaughtOnSubbedThunks = ({ reduxThunkType, data }: PipedErrorPayload) => void;
